import Group from "ol/layer/Group";
import LayerSwitcher from "ol-layerswitcher";
import { createBasemapTileLayers } from "../layers/basemapTileLayers";

export function addBasemapLayersAndControls(map, azureLoginControl) {
  const layerSwitcher = new LayerSwitcher({
    tipLabel: "Basemaps",
    groupSelectStyle: "none",
  });
  const tileLayers = createBasemapTileLayers(azureLoginControl);
  // The main viewer drives basemap selection via ol-layerswitcher, which
  // needs `title` + `type: "base"` and all layers visible (the switcher picks
  // which one to render).
  tileLayers.forEach(({ name, layer }) => {
    layer.set("title", name);
    layer.set("type", "base");
    layer.setVisible(true);
  });
  map.addLayer(
    new Group({
      title: "Base maps",
      layers: tileLayers.map(({ layer }) => layer),
    }),
  );
  map.addControl(layerSwitcher);
}
